import { render, staticRenderFns } from "./ComponentLP.vue?vue&type=template&id=0d6429b3"
import script from "./ComponentLP.vue?vue&type=script&lang=js"
export * from "./ComponentLP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports